export default __webpack_public_path__ + "static/26_31-4a1f955bdc240f737b0ddccf687ece7f.png";